import React from 'react';
import './Certification.css';

const Certification = ({ currentLanguage }) => {
  const getTranslation = (key) => {
    const translations = {
      en: {
        title: 'Certifications & Achievements',
        subtitle: 'Professional credentials and recognition in astrology'
      },
      hi: {
        title: 'प्रमाणन और उपलब्धियां',
        subtitle: 'ज्योतिष में व्यावसायिक प्रमाण पत्र और मान्यता'
      },
      gu: {
        title: 'પ્રમાણપત્રો અને સિદ્ધિઓ',
        subtitle: 'જ્યોતિષમાં વ્યાવસાયિક પ્રમાણપત્રો અને માન્યતા'
      }
    };
    return translations[currentLanguage]?.[key] || translations.en[key];
  };

  return (
    <section id="certification" className="certification">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">{getTranslation('title')}</h2>
          <div className="section-divider"></div>
          <p className="section-subtitle">{getTranslation('subtitle')}</p>
        </div>
        <div className="certification-grid">
          <div className="certification-card">
            <div className="certification-image">
              <img src="/images/certification/c1.jpeg" alt="Astrology Certification" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Certification;